<script setup lang="ts">
import { computed } from "vue";
import AppButtonCircle from "@/components/AppButtonCircle.vue";
const emit = defineEmits(["update:modelValue"]);
const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  min: {
    type: Number,
    required: false,
    default: 0,
  },
  max: {
    type: Number,
    required: false,
    default: 100,
  },
});

const value = computed({
  get: () => props.modelValue ?? 0,
  set: (newValue) => {
    emit("update:modelValue", newValue);
  },
});

const add = () => {
  const newValue = +value.value + 1;

  value.value = newValue;
};

const subtract = () => {
  const newValue = +value.value - 1;
  value.value = newValue;
};
</script>
<template>
  <div class="flex items-center">
    <AppButtonCircle
      :disabled="value <= min"
      @click="subtract"
      icon="fa-minus"
      buttonType="Primary"
      sizeClass="w-[25px] h-[25px]"
      class="mr-4"
    />
    <span class="text-normal-emphasis">{{ value ?? 0 }}</span>
    <AppButtonCircle
      :disabled="max <= value"
      @click="add"
      icon="fa-add"
      buttonType="Primary"
      sizeClass="w-[25px] h-[25px]"
      class="ml-4"
    />
  </div>
</template>
